import './dashboard_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SurveysDashboardView extends Monitoring.Views.SocialContents.DashboardView
  template: JST['backbone/templates/monitoring/dashboard']
  className: 'dashboard'
  id: 'surveys-dashboard'

  initialize: (@options={}) ->
    super(@options)
    @SurveyTopicsView = @_newSurveyTopicsView()

  _dashboardResultsView: ->
    new Monitoring.Views.DashboardSurveyView(@_dashboardResultsViewOptions())

  _newSessionModalView: ->
    @newSessionModalView = new Monitoring.Views.SocialContents.SurveysNewSessionModalView
      mustShowAnalysisButton: @mustShowAnalysisButton()
      uuid: @uuid
      sortedAvailableChannelsByProvider: @getSortedAvailableChannelsByProvider()
      SurveyTopicsView: @SurveyTopicsView
    @newSessionModalView

  _renderSelectViews: ->
    @listenTo(@SurveyTopicsView, 'change', @updateStartButton)
    @$el.find('.select-survey').append(@SurveyTopicsView.render().el)

  _newSurveyTopicsView: ->
    new Monitoring.Views.SocialContents.SurveysSelectView
      surveys: @topics

  getSelectedTopics: ->
    selectedSurvey = @SurveyTopicsView?.selectedSurvey()
    if selectedSurvey then [selectedSurvey] else []

  _canSearch: ->
    @SurveyTopicsView?.anySurveySelected()

  _searchMode: ->
    'survey'

  _firstSearchName: ->
    @getSelectedTopics()[0]?.name or 'Survey'

  _logNewSessionEvent: ->

  getSortedAvailableChannelsByProvider: =>
    []
